module.exports = __webpack_public_path__ + "media/files/sample_agency_check_file-cae111bf2024232573ccc409eb9f38b7.xls";